import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["aria-expanded", "aria-label"]
const _hoisted_2 = {
  class: "ai-pill pointer-events-auto mr-4 flex min-w-0 select-none items-center gap-2.5 rounded-r-full border border-l-0 py-2 pl-1.5 pr-4 font-sans",
  role: "status",
  "aria-live": "polite"
}
const _hoisted_3 = { class: "ai-pill__spark relative flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full" }
const _hoisted_4 = { class: "flex min-w-0 flex-col leading-tight" }
const _hoisted_5 = { class: "ai-pill__title truncate text-[13px] font-semibold tracking-tight" }
const _hoisted_6 = { class: "ai-pill__sub flex items-center text-[11px]" }

import { ChevronLeftIcon, ChevronRightIcon, SparklesIcon } from '@heroicons/vue/24/solid'
import { computed, onMounted, onUnmounted, ref } from 'vue'

import { buildingPlatforms, isBuilding, pollAiBuildingStatus } from '@/composables/aiBuildingStatus'
import { aiBuildingCopy } from '@/config/aiBuildingCopy'
import api from '@/store/api'


export default {
  __name: 'AiBuildingIndicator',
  setup(__props) {

const status = ref(null)
const collapsed = ref(false)
let poller = null

const platforms = computed(() => buildingPlatforms(status.value))
const visible = computed(() => isBuilding(status.value))
const copy = computed(() => aiBuildingCopy(platforms.value))

onMounted(async () => {
  poller = pollAiBuildingStatus((...args) => api.call(...args), {
    onStatus: next => {
      status.value = next
    }
  })

  // Nothing remounts this component - App.vue keeps it alive across every
  // authenticated route - so whenever the poll ends without a final answer the
  // last status has to be dropped, or the pill freezes on screen for good.
  const result = await poller.promise
  if (result && result.reason !== 'done') status.value = null
})

onUnmounted(() => {
  if (poller) poller.cancel()
})

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(_Transition, { name: "ai-pill" }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["ai-rail pointer-events-none fixed right-0 top-[124px] z-20 flex max-w-full items-stretch xl:top-[100px]", collapsed.value ? 'ai-rail--collapsed' : ''])
          }, [
            _createElementVNode("button", {
              type: "button",
              class: "ai-handle pointer-events-auto flex w-10 flex-shrink-0 items-center justify-center rounded-l-full border border-r-0",
              "aria-expanded": !collapsed.value,
              "aria-label": collapsed.value ? 'Show what the AI agent is building' : 'Hide the AI agent status',
              onClick: _cache[0] || (_cache[0] = $event => (collapsed.value = !collapsed.value))
            }, [
              (collapsed.value)
                ? (_openBlock(), _createBlock(_unref(ChevronLeftIcon), {
                    key: 0,
                    class: "ai-handle__chevron h-4 w-4"
                  }))
                : (_openBlock(), _createBlock(_unref(ChevronRightIcon), {
                    key: 1,
                    class: "h-4 w-4"
                  }))
            ], 8, _hoisted_1),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, [
                _createVNode(_unref(SparklesIcon), { class: "h-4 w-4" })
              ]),
              _createElementVNode("span", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(copy.value.title), 1),
                _createElementVNode("span", _hoisted_6, [
                  _createTextVNode(_toDisplayString(copy.value.subtitle) + " ", 1),
                  _cache[1] || (_cache[1] = _createElementVNode("span", {
                    class: "ai-pill__dots",
                    "aria-hidden": "true"
                  }, [
                    _createElementVNode("span"),
                    _createElementVNode("span"),
                    _createElementVNode("span")
                  ], -1))
                ])
              ])
            ])
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

}